<template>
	<div class='ListOfPersonsMin'>
		<div class="header-container">
			<svg v-if="open" @click="open = !open" class="icon">
				<use xlink:href="#icon-arrow-down" />
			</svg>
			<svg v-else @click="open = !open" class="icon">
				<use xlink:href="#icon-arrow-collapse" />
			</svg>
			<div class='header' v-if='label'>
				<div class='title'>{{label}} {{count?`(${count})`:''}}</div>
				<div v-if='count' class='seeAll' @click='$emit("select")'>See all</div>
			</div>
		</div>
		<div class='list' v-if="open">
			<Person v-for='(person, p) in value' :key='p' :person='person' />
		</div>
	</div>
</template>

<script>
import Person from './components/Person/Person.vue';
export default {
	name:       'ListOfPersonsMin',
	props: {
		label: {
			type:    String,
			default: ''
		},
		value: {
			type:    Array,
			default: () => []
		},
		count: {
			type:    Number,
			default: 0
		}
	},
	components: {
		Person
	},
	data() {
		return {
			listOfPeopels: [],
			open:          true,
		};
	},
};
</script>
